import { Box, Skeleton } from '@mui/material';
import type { ReactElement } from 'react';
import {
  StyledDashboardRowIcon,
  StyledDashboardRowViewButton,
  StyledDashboardSectionSkeletonContainer,
} from './DashboardSectionSkeleton.style';

export function DashboardSectionSkeleton(): ReactElement {
  return (
    <StyledDashboardSectionSkeletonContainer>
      <StyledDashboardRowIcon>
        <Skeleton height={48} variant="rectangular" width={48} />
      </StyledDashboardRowIcon>
      <Box sx={{ flexGrow: 1 }}>
        <Skeleton height={24} variant="text" width="70%" />
        <Skeleton height={16} variant="text" width="60%" />
        <StyledDashboardRowViewButton>
          <Skeleton height={16} variant="text" width="10%" />
          <Skeleton height={16} variant="rectangular" width={16} />
        </StyledDashboardRowViewButton>
      </Box>
      <Box>
        <Skeleton height={32} sx={{ borderRadius: '4px' }} variant="rectangular" width={100} />
      </Box>
    </StyledDashboardSectionSkeletonContainer>
  );
}
